import { useSelectedRootLocationConfiguration } from '@infield/features/app-config';
import { createContext } from 'react';

export const defaultValue = {
  useSelectedRootLocationConfiguration: () =>
    useSelectedRootLocationConfiguration(),
};

export type UseTemplatesSearchContextInterface = typeof defaultValue;

export const UseTemplatesSearchContext =
  createContext<UseTemplatesSearchContextInterface>(defaultValue);
